import { FC } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const H2 = styled('h2')<{ color?: 'white' }>(
    ({ theme: { colors }, color }) => css`
        text-align: center;
        ${color === 'white' ? `color: ${colors.white};` : null}
    `
);

export const Loading: FC<{ color?: 'white' }> = ({ color }) => {
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
    }

    return (
        <H2 data-testid="loading-search-results" color={color}>
            Loading...
        </H2>
    );
};
